import { render, staticRenderFns } from "./BrandWizardNavigation.vue?vue&type=template&id=ea3fcdd8&"
import script from "./BrandWizardNavigation.vue?vue&type=script&lang=js&"
export * from "./BrandWizardNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports